import JwtStore from "../flux/JwtStore";
import { Link } from "react-router-dom";
import React from "react";
import styled from "styled-components";
import themeResponsiveProperty from "../components/responsive/themeResponsiveProperty";
import Button from "../components/Button";
import thronThumbnail from "../utils/thronThumbnail";
import thronThumbnailResize from "../utils/thronThumbnailResize";
import JwtStoreActions from "../flux/JwtStoreActions";
import __ from '../utils/translator';

function renderEmailWithFallback(mail, username) {
  if (mail !== null && mail !== '') {
    return mail;
  }

  return username;
}

export default function ConfirmAuthenticationProfile() {
  // @todo 2024-01-12 translate "You are…", "Yes!" and "No, logout"

  return (
    <Container>
      <Content>
        <p>{__('You are currently logged-in as :email, is that you?', { email: renderEmailWithFallback(JwtStore.getMail(), JwtStore.getUsername()) })}</p>

        <ButtonContainer>
          <Button size="medium" onClick={() => {
            JwtStoreActions.confirmAuthentication();
          }}>{__('Yes')}</Button>

          <Link to="/logout">
            <Button size="medium" link>{__('No, logout')}</Button>
          </Link>
        </ButtonContainer>
      </Content>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-image: url("${themeResponsiveProperty(
    props => thronThumbnailResize(thronThumbnail(props.theme.miscContentId.loginMobile), { width: 750, height: 1624 }),
    props => thronThumbnailResize(thronThumbnail(props.theme.miscContentId.loginTablet), { width: 2732, height: 2048 })
  )}");
  background-repeat: no-repeat;
  background-size: cover;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 28rem;
  margin: 1rem;
  padding: 2rem 3rem;
  background-color: #fff;
  border-radius: .25rem;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;
